import type {Locale} from '../locales';
import de from './de';
import en, {type Messages} from './en';
import es from './es';

export type {Messages};

type LeafKeys<T, Prefix extends string = ''> = {
    [K in keyof T & string]: T[K] extends string ? `${Prefix}${K}` : LeafKeys<T[K], `${Prefix}${K}.`>;
}[keyof T & string];

/** A dotted path to a message, e.g. `pricing.card.currentPlan`. Logic modules return these; components call `t`. */
export type MessageKey = LeafKeys<Messages>;

/** The English text of a key, or undefined when en has no such message. Tests use it to check returned keys. */
export function englishMessage(key: string): string | undefined {
    const value = key.split('.').reduce<any>((node, part) => node?.[part], MESSAGES.en);
    return typeof value === 'string' ? value : undefined;
}

/** Shared by vue-i18n in the app and by the Workers build (middleware, shell content). */
export const MESSAGES: Record<Locale, Messages> = {en, es, de};
